<template>
	<div v-if='content'>

		<div class="api_list">
			<div class="api_inner">
				<button class="load_button" @click="downLoad">下载PDF</button>
				<div id="api_list"></div>
				<div class="hexagon">
					<span class="back">返回顶部</span>
				</div>
			</div>
		</div>
		<div class="rigth_content" v-html="content"></div>
	</div>
</template>

<script>
	import '../../assets/js/highlight.min'
	export default {
		name: 'apiContent',
		props: ['content', 'fileName'],
		methods: {
			downLoad() {
				window.location.href = "https://fp.baiwang.com/DownloadService/PublicDownLoad?filePath=bwopen/" + this.fileName + ".pdf"
			},
			follow(boxArr) {
				let scrollTop = $(window).scrollTop()
				$.each(boxArr, function(index, obj) {
					if(scrollTop > obj.minTop && scrollTop < obj.maxTop) {
						$(".api_list").find(".api_item")
							.eq(index)
							.addClass("current")
							.siblings()
							.removeClass("current");
					}
				})
			},
			getBoxHeight(boxArr) {
				let last;
				let leng = $('.rigth_content h2').length - 1;
				$.each($(".rigth_content h2"), function(index, obj) {
					var position = {};
					position.minTop = $(obj).offset().top;
					if(index == 0) {
						position.minTop = 0;
					}
					if(index == leng) {
						position.maxTop = 10000;
					} else {
						last = index + 1;
						position.maxTop = $(".rigth_content h2:eq(" + last + ")").offset().top;
					}
					boxArr.push(position);
				})
				return boxArr
			}
		},
		updated() {
			let that = this;
			let boxArr = []; //标题高度数组
			let len = $("h2").length;
			let obj = $("h2");
			let html = '';
			let timer = null;
			//悬浮列表
			for(var i = 0; i < len; i++) {
				html += '<li class="api_item singletext" attr="s' + i + '">' + obj[i].innerText.substring(2) + '</li>';
				$(obj[i]).attr('id', "s" + i)
			}
			$("#api_list").html(html)
			$("#api_list li").eq(0).addClass('current');
			$("#api_list").on("click", 'li', function() {
				$(this).addClass('current').siblings().removeClass('current');
			})
			
			//保证图片加载完毕有高度了在去取h2的高度，不然会有定位不准的bug
			setTimeout(function(){
				boxArr = that.getBoxHeight(boxArr);
				
			},500)
			
			//楼梯
			let scrollHeight = 0;
			$(window).scroll(function() {
				scrollHeight = $(document).scrollTop()
				if(scrollHeight > 50){
					$(".api_inner").addClass('fixed_box')
				}else{
					$(".api_inner").removeClass('fixed_box')
				}
				clearTimeout(timer);
				timer = setTimeout(function() {
					that.follow(boxArr)
				}, 10);
			});

			//返回顶部
			$('.api_list').on('click', '.hexagon', function() {
				$('html , body').animate({
					scrollTop: 0
				}, 10, function() {
					$(".api_item:eq(0)")
						.addClass("current")
						.siblings()
						.removeClass("current");
				});
			})
			//模拟锚点
			$('.api_list').on('click', 'li', function() {
				var obj = "#" + $(this).attr('attr')
				$("body,html").animate({
					scrollTop: $(obj).offset().top + 2 
				}, 10);
			})

			//代码高亮
			$('pre code').each(function(i, block) {
				hljs.highlightBlock(block);
			});

			//样式重置
			$(".rigth_content h1").addClass('title_font');
			$(".rigth_content h2").addClass('second_font');
			$(".rigth_content p").addClass('remarks_font');
			//页面统计
			var _hmt = _hmt || [];
			(function() {
				var hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?1f856b820b5fecba29d676a42723bce6";
				var s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
			})();

		}
	}
</script>

<style lang="scss">
	.load_button {
		/*position: absolute;*/
		width: 84px;
		height: 32px;
		line-height: 28px;
		border-radius: 4px;
		font-size: 14px;
		font-family: "微软雅黑";
		background: $white;
		color: $hover;
		border: 1px solid $hover;
		margin-bottom: 10px;
		font-weight: 600;
		cursor: pointer;
	}
	
	.api_list {
		cursor: pointer;
		position: absolute;
		top: 20px;
		left: 1100px;
		.api_item {
			display: block;
			font-size: 12px;
			color: $hover;
			border-left: 2px solid $border;
			padding-left: 10px;
			color: $subcolor;
			height: 30px;
			line-height: 30px;
			width: 84px;
		}
		.current {
			color: $hover;
			border-left: 2px solid $hover;
		}
		.fixed_box{
			width: 84px;
		    z-index: 999;
		    opacity: 0.98;
		    position: fixed;
		    top: 100px;
		}
	}
	
	.rigth_content {
		
		float: left;
		padding: 10px 20px 0 20px;
		width: 876px;
		border-left: 1px solid $border;
		img{width: 100%}
		pre {
			margin-top: 10px;
		}
		h1 {
			margin-bottom: 10px;
		}
		p:nth-last-of-type(1),
		p:nth-last-of-type(2) {
			margin: 5px 0;
		}
		h2 {
			margin-bottom: 10px;
			height: 28px;
			border-bottom: 1px solid $border;
			margin-top: 30px;
		}
		.title_font{
			height: auto;
		}
		ul {
			padding-top: 10px;
			li {
				font-size: 14px;
			}
		}
		table {
			border: 1px solid $baseBord;
			font-size: 14px;
			width: 836px;
			margin-top: 10px;
			margin-bottom: 30px;
			thead {
				background: $subcolor;
				color: $white;
				th {
					height: 34px;
					padding-left: 10px;
					text-align: left;
					border-right: 1px solid $white;
				}
				td {}
			}
			tbody {
				td {
					height: 40px;
					text-align: left;
					padding-left: 10px;
					border-right: 1px solid $baseBord;
					border-bottom: 1px solid $baseBord;
				}
			}
		}
		table:nth-of-type(1) {
			thead {
				tr {
					th:nth-child(1) {
						width: 20%;
					}
					th:nth-child(2) {
						width: 20%;
					}
					th:nth-child(3) {
						width: 10%;
					}
					th:nth-child(4) {
						width: 60%;
					}
				}
			}
		}
		table:nth-of-type(2) {
			thead {
				tr {
					th:nth-child(1) {
						width: 15%;
					}
					th:nth-child(2) {
						width: 10%;
					}
					th:nth-child(3) {
						width: 10%;
					}
					th:nth-child(4) {
						width: 10%;
					}
					th:nth-child(5) {
						width: 55%;
					}
				}
			}
		}
		table:nth-of-type(3) {
			thead {
				tr {
					th:nth-child(1) {
						width: 20%;
					}
					th:nth-child(2) {
						width: 20%;
					}
					th:nth-child(3) {
						width: 10%;
					}
					th:nth-child(4) {
						width: 10%;
					}
					th:nth-child(5) {
						width: 40%;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/public/ApiContent.vue